// Semantic design tokens — map roles to primitive CSS variables.
// Use these instead of raw CSS variables when assigning meaning to a color.
// Sourced from Figma Design System: https://www.figma.com/design/W3YeU8lkVPvaswKHglfzNz/

export const semanticColors = {
  text: {
    primary: 'var(--mui-shades-900)',
    secondary: 'var(--mui-shades-400)',
    disabled: 'var(--mui-shades-300)',
    onDark: 'var(--mui-shades-0)',
    link: 'var(--mui-primary-500)',
    error: 'var(--mui-critical-500)',
    success: 'var(--mui-success-500)',
    warning: 'var(--mui-warning-500)',
    info: 'var(--mui-info-500)',
  },

  background: {
    surface: 'var(--mui-shades-0)',
    subtle: 'var(--mui-shades-50)',
    muted: 'var(--mui-shades-100)',
    overlay: 'var(--mui-shades-1000)',
    brand: 'var(--mui-primary-500)',
    brandSubtle: 'var(--mui-primary-100)',
    brandDark: 'var(--mui-primary-800)',
  },

  border: {
    default: 'var(--mui-shades-100)',
    strong: 'var(--mui-shades-200)',
    focus: 'var(--mui-primary-500)',
    error: 'var(--mui-critical-500)',
    success: 'var(--mui-success-500)',
  },

  feedback: {
    errorFg: 'var(--mui-critical-500)',
    errorBg: 'var(--mui-critical-25)',
    errorBgMd: 'var(--mui-critical-200)',
    successFg: 'var(--mui-success-500)',
    successBg: 'var(--mui-success-200)',
    warningFg: 'var(--mui-warning-500)',
    warningBg: 'var(--mui-warning-200)',
    infoFg: 'var(--mui-info-500)',
    infoBg: 'var(--mui-info-200)',
  },

  interactive: {
    primary: 'var(--mui-primary-500)',
    primaryHover: 'var(--mui-primary-600)',
    primaryActive: 'var(--mui-primary-700)',
    primaryDisabled: 'var(--mui-primary-200)',
    primarySubtle: 'var(--mui-primary-100)',
  },
} as const

export type SemanticColors = typeof semanticColors
